import { render } from "./EtcItem.vue?vue&type=template&id=dd4b48d8&scoped=true"
import script from "./EtcItem.vue?vue&type=script&lang=js"
export * from "./EtcItem.vue?vue&type=script&lang=js"

import "./EtcItem.vue?vue&type=style&index=0&id=dd4b48d8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd4b48d8"]])

export default __exports__